import { createUseQuery } from 'api/common/createUseQuery'
import { fetchProjectsStatus, ProjectStatus } from 'api/fetchers/fetchProjectsStatus'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useProjectsStatus = createUseQuery({
  queryKey: ApiQueryKeys.PROJECTS,
  fetcher: fetchProjectsStatus,
  selector: res => (res?.data as ProjectStatus | undefined) ?? ({} as ProjectStatus),
})
